import { isEmpty } from 'lodash'

import type { CloudMarketplace } from '../../productsListing/types'
import type {
  Contract,
  ContractsListingApiContracts,
  ContractsListingApiData,
} from '../types'
import { updateResponseDataForCloudProvider } from './updateResponseDataForCloudProvider'

export const getNormalizedContractsResponseData = (
  responseDataInput: unknown,
  cloudProvider: CloudMarketplace
) => {
  let responseData = responseDataInput as ContractsListingApiData
  if (cloudProvider === 'GCP') {
    responseData = {
      contracts: responseDataInput as ContractsListingApiData['contracts'],
    }
  }
  if (!isEmpty(responseData.contracts)) {
    const contractsBlock =
      responseData.contracts as ContractsListingApiContracts
    const updatedContracts = updateResponseDataForCloudProvider(
      contractsBlock.rows as Contract[],
      cloudProvider
    )
    responseData = {
      ...responseData,
      contracts: {
        ...contractsBlock,
        rows: updatedContracts,
      },
    }
  }

  return responseData
}
